<template> 
  <v-card v-show="isShow" tile>
    <v-container fluid style="padding-bottom: 96px;">
      <v-card-title v-if="isMoneyVisible">
        獎金分配狀況:
        部門分配獎金合計: {{totalBudget}}
        主管分配獎金合計: {{totalAssignedTaskBudget}}
        實發獎金合計:
                  <span v-if="totalReleaseBonus != null">${{totalReleaseBonus}} </span>
                  <v-btn
                    v-else
                    class="ml-1 mr-1"
                    color="white"
                    text
                    small
                    @click.stop="viewTotalReleaseBonus"
                  >計算</v-btn>
      </v-card-title>
      
      <v-card-title>
        團隊成員與獎金分配(招標中)
        <!-- 新增任務，自動建立部門預算 -->
        <v-tooltip
          top
          v-if="canEditTaskOfThisDepartment"
        >
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              style="float: right"
            >
              <v-btn
                :disabled="isProjectFinished"
                color="primary "
                dark
                @click.stop="showTaskCreator('招標中')"
              >
                <v-icon>mdi-plus</v-icon>

              </v-btn>
            </span>
          </template>
          <span v-if="!isProjectFinished">新增任務</span>
          <span v-else>專案已結束</span>
        </v-tooltip>
        <!-- 新增部門預算 -->
        <!-- <v-tooltip top>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn v-if="canEditProjectBudget" :disabled="!canAddBidingDepartment || project.Status != '招標中' || isProjectFinished" color="primary" dark class="ml-2" @click="addProjectDepartment('招標中')">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </template>
          <span v-if="isProjectFinished">專案已結束</span>
          <span v-else-if="!canAddBidingDepartment">所有部門皆已分配</span>
          <span v-else-if="project.Status != '招標中'">專案並未招標中</span>
          <span v-else>新增招標中的部門獎金分配</span>
        </v-tooltip> -->
      </v-card-title>

      <!-- 取得該專案所有任務，根據部門劃分。如何分辨招標中或已招標？ -->

      <!-- 這邊有點慢。ex: 臺北市內湖區康寧國民小學	-->
      <v-simple-table class="table-black">
        <template v-slot:default>
          <template v-for="(budget, idx) in displayBidingDepartmentBudgets">
            <thead :key="`theaad-biding-${budget.ID}`">
                <tr v-if="idx != 0" class="table-divider">
                    <th :colspan="canEditTask?8:7" class="text-left"></th>
                </tr>
            </thead>
            <task-table 
              :key="`tbody-biding-${budget.ID}`" 
              :item="budget"
              project-stage="招標中"
              @edit="editProjectDepartment"
              @remove="deleteBudget"/>
          </template>
        </template>
      </v-simple-table>
      <v-btn 
        v-if="!isShowBiddingTasks && displayBidingDepartmentBudgets != bidingDepartmentBudgets" 
        color="primary" @click="isShowBiddingTasks = true">
        {{displayBidingDepartmentBudgets.length ? '載入其他部門' : '載入顯示'}}
      </v-btn>
      
      <v-card-title v-if="canEditWorkingDepartment" style="margin-top: 60px;">
        團隊成員與獎金分配(執行中)
        <!-- 新增部門預算 -->
        <!-- <v-tooltip top>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn v-if="canEditProjectBudget" :disabled="!canAddWorkingDepartment || project.Status != '執行中' || isProjectFinished" color="primary" dark class="ml-2" @click="addProjectDepartment('執行中')">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </template>
          <span v-if="isProjectFinished">專案已結束</span>
          <span v-else-if="!canAddWorkingDepartment">所有部門皆已分配</span>
          <span v-else-if="project.Status != '執行中'">專案並未執行中</span>
          <span v-else>新增執行中的部門獎金分配</span>
        </v-tooltip> -->
        <v-tooltip
          top
          v-if="canEditTaskOfThisDepartment"
        >
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              style="float: right"
            >
              <v-btn
                :disabled="isProjectFinished"
                color="primary "
                dark
                @click.stop="showTaskCreator('執行中')"
              >
                <v-icon>mdi-plus</v-icon>

              </v-btn>
            </span>
          </template>
          <span v-if="project.Status != '執行中'">專案並未執行中</span>
          <span v-else-if="!isProjectFinished">新增任務</span>
          <span v-else>專案已結束</span>
        </v-tooltip>
      </v-card-title>
      <!-- 這邊有點慢，ex: 新北市捷運工程局(契約)	-->
      <!-- 預設只載入自己部門的專案 -->
      <v-simple-table v-if="canEditWorkingDepartment" class="table-black">
          <template v-slot:default>
              <template v-for="(budget, idx) in displayWorkingDepartmentBudgets">
                  <thead :key="`theaad-working-${budget.ID}`">
                      <tr v-if="idx != 0" class="table-divider">
                          <th :colspan="canEditTask?8:7" class="text-left"></th>
                      </tr>
                  </thead>
                  <task-table 
                    :key="`tbody-working-${budget.ID}`" 
                    :item="budget"
                    project-stage="執行中"
                    @edit="editProjectDepartment"
                    @remove="deleteBudget"/>
              </template>
          </template>
      </v-simple-table>
      <v-btn 
        v-if="!isShowWorkingTasks && canEditWorkingDepartment && (displayWorkingDepartmentBudgets != workingDepartmentBudgets)" 
        color="primary" @click="isShowWorkingTasks = true">
        {{displayWorkingDepartmentBudgets.length ? '載入其他部門' : '載入顯示'}}
      </v-btn>
    </v-container>

    <!-- <v-fab-transition
      v-if="canEditProject">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            @click="showProjectEditor"
            v-on="on"
            v-show="isShow"
            color="black"
            class="v-btn--fixed"
            dark
            absolute
            right
            bottom
            fab
            style="bottom:28px;">
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
        <span>編輯專案</span>
      </v-tooltip>
    </v-fab-transition> -->

    <budget-addedit-dialog v-model="isShowBudgetAddeditDialog" :editing-id="editingBudgetId" :project-id="projectId" :stage="editingStage"/>

    <task-addedit-dialog
      v-if="canEditTask"
      v-model="isShowTaskAddeditDialog"
      :editing-id="editingTaskId"
      :project-id="projectId"
      :stage="editingStage"
      :department-id="myDepartment.ID"
      :project-department-budget-id="null"
    />

    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate color="white"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import BudgetAddeditDialog from "@/ui/project/budget/budget-addedit-dialog.vue";
import TaskAddeditDialog from "@/ui/project/task/task-addedit-dialog.vue";
import TaskTable from "./project-dialog-task-table.vue";
export default {
  components: { BudgetAddeditDialog, TaskTable, TaskAddeditDialog },
  props: {
    projectId: {
      type: Number,
      required: true
    },
    isShow: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    isLoading: false,
    // project department budget
    isShowBudgetAddeditDialog: false,
    editingBudgetId: -1,
    editingStage: "",
    totalReleaseBonus: null,
    isShowTotalReleaseBonus: false,
    isShowWorkingTasks: false, // UI&資料太多，效能差，延遲載入
    isShowBiddingTasks: false, // UI&資料太多，效能差，延遲載入
    // task
    editingTaskId: -1,
    isShowTaskAddeditDialog: false,
  }),
  computed: {
    canEditTaskOfThisDepartment() {
      return (
        this.canEditTask &&
        (this.myLevel > 10 || (this.myLevel == 10))
      );
    },
    canAddBidingDepartment() {
      let usedDepartmentIDList = this.bidingDepartmentBudgets.map(
        o => o.DepartmentID
      );
      for (var item of this.activeDepartmentList) {
        if (!usedDepartmentIDList.includes(item.ID)) return true;
      }
      return false;
    },
    canAddWorkingDepartment() {
      let usedDepartmentIDList = this.workingDepartmentBudgets.map(
        o => o.DepartmentID
      );
      for (var item of this.activeDepartmentList) {
        if (!usedDepartmentIDList.includes(item.ID)) return true;
      }
      return false;
    },
    project() {
      return this.projects.find(o => o.ID == this.projectId) || {};
    },
    bidingDepartmentBudgets() {
      return this.$store.state.projectDepartmentBudget.list.filter(
        o => o.ProjectID == this.projectId && o.ProjectStage == "招標中"
      );
    },
    displayBidingDepartmentBudgets() {
      if (!this.isShowBiddingTasks) {
        return this.bidingDepartmentBudgets.filter(o=>o.DepartmentID == this.myDepartment.ID)
      }
      return this.bidingDepartmentBudgets
    },
    workingDepartmentBudgets() {
      return this.$store.state.projectDepartmentBudget.list.filter(
        o => o.ProjectID == this.projectId && o.ProjectStage == "執行中"
      );
    },
    displayWorkingDepartmentBudgets() {
      if (!this.isShowWorkingTasks) {
        return this.workingDepartmentBudgets.filter(o=>o.DepartmentID == this.myDepartment.ID)
      }
      return this.workingDepartmentBudgets
    },
    canEditWorkingDepartment() {
      return ["執行中", "已結案", "已完成"].includes(this.project.Status);
    },
    isProjectFinished() {
      return ["未得標", "已結案", "已完成"].includes(this.project.Status);
    },
    totalBudget() {
      return (
        this.bidingDepartmentBudgets.reduce(
          (sum, item) => sum + item.Budget,
          0
        ) +
        this.workingDepartmentBudgets.reduce(
          (sum, item) => sum + item.Budget,
          0
        )
      );
    },
    totalAssignedTaskBudget() {
      return this.projectActiveTasks.reduce(
        (sum, task) => sum + task.Amount,
        0
      );
    },
    projectActiveTasks() {
      return this.activeTaskList.filter(o => o.ProjectID == this.projectId);
    },
    isMoneyVisible () {
      return this.myLevel >= 10
    },
    ...mapGetters([
      "myLevel",
      "me",
      "activeTaskList",
      "canEditProject",
      "canEditProjectBudget",
      "canEditTask",
      "activeDepartmentList",
      "projects",
      "taskWorkingItems",
      "myDepartment",
    ])
  },
  methods: {
    showTaskCreator(projectStage) {
      this.editingTaskId = -1;
      this.editingStage = projectStage;
      this.isShowTaskAddeditDialog = true;
    },
    viewTotalReleaseBonus() {
      this.totalReleaseBonus = this.calculateTotalReleaseBonus()
    },
    calculateTotalReleaseBonus() {
      return this.taskWorkingItems
        .filter(
          o => this.projectActiveTasks.findIndex(t => t.ID == o.TaskID) >= 0
        )
        .reduce((sum, o) => sum + (o.BonusReleasedAt ? o.Bonus : 0), 0);
    },
    // project department budget
    addProjectDepartment(projectStage) {
      this.editingBudgetId = -1;
      this.editingStage = projectStage;
      this.isShowBudgetAddeditDialog = true;
    },
    editProjectDepartment(budget) {
      this.editingBudgetId = budget.ID;
      this.editingStage = budget.ProjectStage;
      this.isShowBudgetAddeditDialog = true;
    },
    deleteBudget(item) {
      const removingIdx = this.$store.state.projectDepartmentBudget.list.indexOf(
        item
      );
      this.isLoading = true;
      this.$services.projectDepartmentBudget
        .delete(this, item.ID)
        .then(res => {
          this.$store.state.projectDepartmentBudget.list.splice(removingIdx, 1);
          // this.$alertMessage("成功刪除該部門配置!");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showProjectEditor () {
      this.$store.state.UI.dialog.project.isShow = false;
      this.$store.state.UI.dialog.projectEditor.id = this.projectId;
      this.$store.state.UI.dialog.projectEditor.isShow = true;
      // this.$router.push({
      //   name: "project-editor",
      //   params: { id: this.projectId }
      // });
    }
  },
  mounted () {
    this.viewTotalReleaseBonus()
  }
};
</script>

<style scoped>
.table-divider {
  background-color: #424242;
}
</style>